export default {
  touchPrompt: {
    bottom: "1%",
    left: "50%",
  },

  showRegistrationModalOnQr: false,

  general: {
    showSoldNeighbourhoods: false,
    appResetTimeoutMinutes: 15,
  },
  filter: {
    enabled: false,
  },
};
